import { gql } from '@apollo/client';

export const VALIDATE_CUSTOMER = gql`
  query Query(
    $accountNumber: String
    $dob: Date
    $firstName: String
    $lastName: String
  ) {
    validateCustomerWebsite(
      accountNumber: $accountNumber
      dob: $dob
      firstName: $firstName
      lastName: $lastName
    ) {
      primaryContactCustomerNumber
      account {
        accountId
        fuel
        accountType
      }
    }
  }
`;

export const REGISTER_DIRECT_DEBIT = gql`
  mutation RegisterDirectDebitWebsite(
    $registerDirectDebitInput: RegisterDirectDebitInput
  ) {
    registerDirectDebitWebsite(
      registerDirectDebitInput: $registerDirectDebitInput
    ) {
      successfullySubmitted
      error {
        message
        code
      }
      timestamp
    }
  }
`;
